<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title> Unificar Fichas de Paciente </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6" sm="4">
              <v-alert class="mt-2 explanation" color="purple" dark outlined>
                El paciente que seleccione arriba será el paciente que va a
                quedar y el que seleccione abajo el que se borrará. Todas las
                transacciones (turnos, cobros, historial clínico y demás
                transacciones) del paciente de abajo se traspasarán al paciente
                de arriba previo a borrar el mismo. Esta acción es de carácter
                irreversible.
              </v-alert>
            </v-col>
            <v-col cols="12" md="6" sm="4">
              <div class="validations">
                <ul>
                  <li>
                    <span>Selección de paciente a dejar</span
                    ><v-icon v-if="paciente.idPaciente" class="icon-check"
                      >mdi-check</v-icon
                    >
                    <v-icon v-else class="icon-close">mdi-close</v-icon>
                  </li>
                  <li>
                    <span>Selección de paciente a borrar</span
                    ><v-icon v-if="pacienteBorrar.idPaciente" class="icon-check"
                      >mdi-check</v-icon
                    >
                    <v-icon v-else class="icon-close">mdi-close</v-icon>
                  </li>
                  <li>
                    <span>Ambos pacientes son distintos en el sistema</span
                    ><v-icon
                      v-if="paciente.idPaciente !== pacienteBorrar.idPaciente"
                      class="icon-check"
                      >mdi-check</v-icon
                    >
                    <v-icon v-else class="icon-close">mdi-close</v-icon>
                  </li>
                </ul>
              </div>
            </v-col>
          </v-row>
          <div class="paciente-queda">
            <v-row>
              <h3>Paciente que queda</h3>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="paciente.dni"
                  prepend-icon="mdi-account"
                  hint="Ingrese el DNI del Paciente y apriete enter o toque fuera de este cuadro de texto. Si el paciente ya existe, se verán sus datos. Si el paciente no existe, complete los datos y al guardar el turno el paciente quedará registrado. Puede también buscar el paciente por apellido y nombre haciendo click en la lupa"
                  label="D.N.I *"
                  dense
                  required
                  @keypress="onlyNumber"
                  @keypress.enter="$event.target.blur()"
                  @blur="buscarPacienteDni(1)"
                  :rules="requiredRules"
                  maxlength="9"
                ></v-text-field>
              </v-col>
              <v-col cols="2" sm="2" md="2">
                <v-btn color="primary" @click="buscarPaciente(1)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="paciente.apellidos"
                  prepend-icon="mdi-account"
                  label="Apellidos *"
                  dense
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="paciente.nombres"
                  prepend-icon="mdi-account"
                  label="Nombres *"
                  dense
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="paciente.fechaNac"
                  :value="paciente.fechaNac"
                  label="Fecha de Nacimiento"
                  prepend-icon="mdi-calendar"
                  type="date"
                  dense
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="sexo"
                  v-model="paciente.sexo"
                  item-text="paciente.sexo"
                  item-value="paciente.sexo"
                  label="Sexo"
                  dense
                  prepend-icon="mdi-account"
                  disabled
                ></v-select>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="paciente.direccion"
                  prepend-icon="mdi-map-marker"
                  label="Direccion"
                  dense
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="paciente.localidad"
                  prepend-icon="mdi-map-marker"
                  label="Localidad"
                  dense
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="paciente.celular"
                  prepend-icon="mdi-cellphone"
                  label="Celular"
                  dense
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="paciente.telefono"
                  prepend-icon="mdi-phone"
                  label="Telefono"
                  dense
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="paciente.mail"
                  prepend-icon="mdi-email"
                  label="E-mail"
                  dense
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="paciente.observaciones"
                  prepend-icon="mdi-account"
                  label="Observaciones del Paciente"
                  dense
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-divider></v-divider>
          <div class="paciente-elimina">
            <v-row>
              <h3>Paciente que se elimina</h3>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="pacienteBorrar.dni"
                  prepend-icon="mdi-account"
                  hint="Ingrese el DNI del Paciente y apriete enter o toque fuera de este cuadro de texto. Si el paciente ya existe, se verán sus datos. Si el paciente no existe, complete los datos y al guardar el turno el paciente quedará registrado. Puede también buscar el paciente por apellido y nombre haciendo click en la lupa"
                  label="D.N.I *"
                  dense
                  required
                  @keypress="onlyNumber"
                  @keypress.enter="$event.target.blur()"
                  @blur="buscarPacienteDni(2)"
                  :rules="requiredRules"
                  maxlength="9"
                ></v-text-field>
              </v-col>
              <v-col cols="2" sm="2" md="2">
                <v-btn color="primary" @click="buscarPaciente(2)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="pacienteBorrar.apellidos"
                  prepend-icon="mdi-account"
                  label="Apellidos *"
                  dense
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="pacienteBorrar.nombres"
                  prepend-icon="mdi-account"
                  label="Nombres *"
                  dense
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="pacienteBorrar.fechaNac"
                  :value="pacienteBorrar.fechaNac"
                  label="Fecha de Nacimiento"
                  prepend-icon="mdi-calendar"
                  type="date"
                  dense
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="sexo"
                  v-model="pacienteBorrar.sexo"
                  item-text="paciente.sexo"
                  item-value="paciente.sexo"
                  label="Sexo"
                  dense
                  prepend-icon="mdi-account"
                  disabled
                ></v-select>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="pacienteBorrar.direccion"
                  prepend-icon="mdi-map-marker"
                  label="Direccion"
                  dense
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="pacienteBorrar.localidad"
                  prepend-icon="mdi-map-marker"
                  label="Localidad"
                  dense
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="pacienteBorrar.celular"
                  prepend-icon="mdi-cellphone"
                  label="Celular"
                  dense
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="pacienteBorrar.telefono"
                  prepend-icon="mdi-phone"
                  label="Telefono"
                  dense
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="pacienteBorrar.mail"
                  prepend-icon="mdi-email"
                  label="E-mail"
                  dense
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="pacienteBorrar.observaciones"
                  prepend-icon="mdi-account"
                  label="Observaciones del Paciente"
                  dense
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            :disabled="
              !paciente.idPaciente ||
                !pacienteBorrar.idPaciente ||
                paciente.idPaciente === pacienteBorrar.idPaciente
            "
            @click.stop="unificarFichas"
            >Unificar</v-btn
          >

          <v-btn color="error" @click.stop="show = false">Salir</v-btn>
        </v-card-actions>
        <BuscarPacienteTurno
          :visible="showBuscarPaciente"
          @close="showBuscarPaciente = false"
          @seleccionarPaciente="seleccionarPaciente($event)"
        ></BuscarPacienteTurno>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<style scoped lang="scss">
.explanation {
  min-height: 100px;
}
.paciente-queda {
  border: 1px solid green;
  border-radius: 20px;
  padding: 0.5rem;
  color: green;
  margin-bottom: 2rem;
  h3 {
    margin-left: 1rem;
    margin-bottom: 1.5rem;
  }
}
.paciente-elimina {
  color: red;
  border: 1px solid red;
  border-radius: 20px;
  padding: 0.5rem;
  margin-top: 2rem;
  h3 {
    margin-left: 1rem;
    margin-bottom: 1.5rem;
  }
}
.validations {
  border: 1px solid orange;
  border-radius: 4px;
  margin-top: 8px;

  li {
    font-size: 1rem;
    color: black;
    margin: 0.4rem;
    span {
      margin-right: 0.5rem;
    }
    .icon-check::before {
      color: green;
    }
    .icon-close::before {
      color: red;
    }
  }
}
</style>
<script>
import axios from "../../axios-auth.js";
import BuscarPacienteTurno from "../Turnos/BuscarPacienteTurno.vue";

export default {
  components: {
    BuscarPacienteTurno,
  },
  data: (vm) => ({
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    paciente: {
      dni: "",
      apellidos: "",
      nombres: "",
      direccion: "",
      localidad: "",
      celular: "",
      telefono: "",
      mail: "",
      sexo: "",
      observaciones: "",
      fechaNac: null,
      sexo: null,
      idPaciente: null,
    },
    pacienteBorrar: {
      dni: "",
      apellidos: "",
      nombres: "",
      direccion: "",
      localidad: "",
      celular: "",
      telefono: "",
      mail: "",
      sexo: "",
      observaciones: "",
      fechaNac: null,
      sexo: null,
      idPaciente: null,
    },
    sexo: ["FEMENINO", "MASCULINO", "OTRO"],
    showBuscarPaciente: false,
    tipoPaciente: null,
  }),

  props: ["visible"],

  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.vaciarModels(1);
          this.vaciarModels(2);
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: alertInfo.timer,
      });
    },
    buscarPacienteDni(tipoPaciente) {
      if (tipoPaciente === 1) {
        if (isNaN(this.paciente.dni)) {
          this.showAlert({
            timer: 3200,
            icon: "error",
            title: "El D.N.I. debe estar compuesto sólo por números.",
            vm: this,
          });
          this.paciente.dni = "";
          this.paciente.idPaciente = 0;
          return;
        }
        if (this.paciente.dni != "" && this.paciente.dni != null)
          this.paciente.dni = parseInt(this.paciente.dni);

        const pacientesData = {
          dni: this.paciente.dni,
          idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
        };
        let self = this;
        axios
          .get("/Paciente/GetPacienteDniTurno?", {
            params: {
              dni: pacientesData.dni,
              idInstitucion: pacientesData.idInstitucion,
            },
          })
          .then(function(response) {
            if (response.data != "" && response.data != null) {
              self.paciente.apellidos = response.data.apellidos;
              self.paciente.nombres = response.data.nombres;
              self.paciente.idPaciente = response.data.idpaciente;
              if (response.data.fechanacimiento == "0001-01-01T00:00:00")
                self.paciente.fechaNac = "";
              else
                self.paciente.fechaNac = response.data.fechanacimiento.substring(
                  0,
                  10
                );
              self.paciente.sexo = response.data.sexo;
              self.paciente.direccion = response.data.direccion;
              self.paciente.localidad = response.data.localidad;
              self.paciente.telefono = response.data.telefono;
              self.paciente.celular = response.data.celular;
              self.paciente.mail = response.data.email;
              self.paciente.observaciones = response.data.observaciones;
            } else {
              self.vaciarModels(1);
            }
          })
          .catch(function(error) {});
      } else {
        if (isNaN(this.pacienteBorrar.dni)) {
          this.showAlert({
            timer: 3200,
            icon: "error",
            title: "El D.N.I. debe estar compuesto sólo por números.",
            vm: this,
          });
          this.pacienteBorrar.dni = "";
          this.pacienteBorrar.idPaciente = 0;
          return;
        }
        if (this.pacienteBorrar.dni != "" && this.pacienteBorrar.dni != null)
          this.pacienteBorrar.dni = parseInt(this.pacienteBorrar.dni);

        const pacientesData = {
          dni: this.pacienteBorrar.dni,
          idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
        };
        let self = this;
        axios
          .get("/Paciente/GetPacienteDniTurno?", {
            params: {
              dni: pacientesData.dni,
              idInstitucion: pacientesData.idInstitucion,
            },
          })
          .then(function(response) {
            if (response.data != "" && response.data != null) {
              self.pacienteBorrar.apellidos = response.data.apellidos;
              self.pacienteBorrar.nombres = response.data.nombres;
              self.pacienteBorrar.idPaciente = response.data.idpaciente;
              if (response.data.fechanacimiento == "0001-01-01T00:00:00")
                self.pacienteBorrar.fechaNac = "";
              else
                self.pacienteBorrar.fechaNac = response.data.fechanacimiento.substring(
                  0,
                  10
                );
              self.pacienteBorrar.sexo = response.data.sexo;
              self.pacienteBorrar.direccion = response.data.direccion;
              self.pacienteBorrar.localidad = response.data.localidad;
              self.pacienteBorrar.telefono = response.data.telefono;
              self.pacienteBorrar.celular = response.data.celular;
              self.pacienteBorrar.mail = response.data.email;
              self.pacienteBorrar.observaciones = response.data.observaciones;
            } else {
              self.vaciarModels(2);
            }
          })
          .catch(function(error) {});
      }
    },
    seleccionarPaciente(item) {
      if (this.tipoPaciente === 1) {
        this.paciente.dni = item.nrodocumento;
        this.paciente.apellidos = item.apellidos;
        this.paciente.nombres = item.nombres;
        if (item.fechanacimiento == "0001-01-01T00:00:00")
          this.paciente.fechaNac = "";
        else this.paciente.fechaNac = item.fechanacimiento.substring(0, 10);
        this.paciente.sexo = item.sexo;
        this.paciente.localidad = item.localidad;
        this.paciente.direccion = item.direccion;
        this.paciente.celular = item.celular;
        this.paciente.mail = item.email;
        this.paciente.telefono = item.telefono;
        this.paciente.observaciones = item.observaciones;
        this.paciente.idPaciente = item.idpaciente;
      } else {
        this.pacienteBorrar.dni = item.nrodocumento;
        this.pacienteBorrar.apellidos = item.apellidos;
        this.pacienteBorrar.nombres = item.nombres;
        if (item.fechanacimiento == "0001-01-01T00:00:00")
          this.pacienteBorrar.fechaNac = "";
        else
          this.pacienteBorrar.fechaNac = item.fechanacimiento.substring(0, 10);
        this.pacienteBorrar.sexo = item.sexo;
        this.pacienteBorrar.localidad = item.localidad;
        this.pacienteBorrar.direccion = item.direccion;
        this.pacienteBorrar.celular = item.celular;
        this.pacienteBorrar.mail = item.email;
        this.pacienteBorrar.telefono = item.telefono;
        this.pacienteBorrar.observaciones = item.observaciones;
        this.pacienteBorrar.idPaciente = item.idpaciente;
      }

      this.showBuscarPaciente = false;
    },
    buscarPaciente(tipoPaciente) {
      this.showBuscarPaciente = true;
      this.tipoPaciente = tipoPaciente;
    },
    vaciarModels(tipoPaciente) {
      if (tipoPaciente === 1) {
        this.paciente.apellidos = "";
        this.paciente.nombres = "";
        this.paciente.direccion = "";
        this.paciente.localidad = "";
        this.paciente.celular = "";
        this.paciente.telefono = "";
        this.paciente.mail = "";
        this.paciente.observaciones = "";
        this.paciente.fechaNac = null;
        this.paciente.sexo = null;
        this.paciente.idPaciente = null;
        this.paciente.dni = "";
      } else {
        this.pacienteBorrar.dni = "";
        this.pacienteBorrar.apellidos = "";
        this.pacienteBorrar.nombres = "";
        this.pacienteBorrar.direccion = "";
        this.pacienteBorrar.localidad = "";
        this.pacienteBorrar.celular = "";
        this.pacienteBorrar.telefono = "";
        this.pacienteBorrar.mail = "";
        this.pacienteBorrar.observaciones = "";
        this.pacienteBorrar.fechaNac = null;
        this.pacienteBorrar.sexo = null;
        this.pacienteBorrar.idPaciente = null;
      }
    },
    unificarFichas() {
      this.$swal({
        title: "Unificar Fichas",
        text:
          "¿Desea unificar la ficha del paciente seleccionado abajo en la ficha seleccionada arriba?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const datosFicha = {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            idPaciente: this.paciente.idPaciente,
            idPacienteBorrar: this.pacienteBorrar.idPaciente,
          };
          let self = this;
          axios
            .post("/Paciente/UnificarFichas", datosFicha)
            .then((response) => {
              self.$refs.form.resetValidation();
              self.vaciarModels(1);
              self.vaciarModels(2);

              document.getElementsByClassName(
                "v-dialog--active"
              )[0].scrollTop = 0;
              self.showAlert({
                timer: 3200,
                icon: "success",
                title: "Fichas unificadas exitosamente",
                vm: self,
              });
              self.$emit("fichasUnificadas");
            })
            .catch((error) => {
              self.showAlert({
                timer: 3200,
                icon: "error",
                title: "Las fichas no pudieron ser unificadas",
                vm: this,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
  },
};
</script>
